import { AccessListController } from './access-list.controller'

function accessList () {
  return {
    restrict: 'E',
    scope: {
      itemsToShow: '<',
      loadMoreItems: '&',
      data: '<',
      itemType: '<'
    },
    templateUrl: '/core/directives/access-list/access-list.html?$$REVISION$$',
    controller: AccessListController
  }
}

export { accessList }
